import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { PRICE, TOTAL_VALUE, stack } from '../data/offer';
export function ValueStack() {
  return <section id="offer" className="w-full scroll-mt-16 bg-carbon-900 py-16 sm:py-20 lg:py-28" aria-labelledby="offer-heading" data-id="element-222" data-mp="1q9xks9e38g40">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-223" data-mp="2hzsojb2p08c7">
        <SectionHeading id="offer-heading" eyebrow="The offer" title={<>
              $552 of coaching system.
              <span className="block text-mint" data-id="element-225" data-mp="2980g15x8b9a9">One payment of $27.</span>
            </>} data-id="element-224" data-mp="2i0aq8n84jeri" />

        <div className="mx-auto mt-12 max-w-2xl overflow-hidden rounded-2xl border border-mint-deep/50 bg-carbon-800 sm:mt-14" data-id="element-226" data-mp="2d7r3p0rgl9ak">
          <ul data-id="element-227" data-mp="30x3mmscl8vq2">
            {stack.map(item => <li key={item.label} className="flex items-center justify-between gap-4 border-b border-carbon-line px-5 py-4 sm:gap-6 sm:px-8 sm:py-5" data-id="element-228" data-mp="35pmv5awf50o0">
                <span className="flex items-start gap-3" data-id="element-229" data-mp="1ogs4rm32e0it">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint" aria-hidden="true" data-id="element-230" data-mp="1oe75n4u5hyor" />
                  <span className={`text-sm leading-snug sm:text-base ${item.isCore ? 'font-semibold text-paper' : 'text-paper-dim'}`} data-id="element-231" data-mp="23798jc3692iv">
                    {item.label}
                  </span>
                </span>
                <span className="shrink-0 font-semibold tabular-nums text-paper-dim" data-id="element-232" data-mp="286c13x1ytg9y">
                  {item.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-6 bg-carbon-700 px-6 py-5 sm:px-8" data-id="element-233" data-mp="2h68sw7jniv98">
              <span className="text-[12px] font-bold uppercase tracking-[0.18em] text-paper-dim" data-id="element-234" data-mp="rqj7s8hip2wn">
                Total value
              </span>
              <span className="font-display text-xl tabular-nums text-paper-dim line-through" data-id="element-235" data-mp="2mtfl6jns4jzt">
                {TOTAL_VALUE}
              </span>
            </li>
          </ul>

          <div className="px-5 py-9 text-center sm:px-10 sm:py-10" data-id="element-236" data-mp="2rud4x0oftm3f">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-mint sm:text-[12px]" data-id="element-237" data-mp="2vt2l110v1hqr">
              Get it all today for only
            </p>
            <p className="mt-3 font-display text-[60px] leading-none text-paper sm:text-[72px]" data-id="element-238" data-mp="35s9xzn3onadc">
              {PRICE}
            </p>
            <p className="mt-3 text-sm text-paper-dim" data-id="element-239" data-mp="3aptpvptazlnr">
              One-time payment in USD. Lifetime access to all 6 PDF files.
            </p>
            <div className="mt-8" data-id="element-240" data-mp="3jjf4n95gx2x6">
              <CtaButton size="lg" note="Secure checkout — instant PDF download" data-id="element-241" data-mp="3jjon8bo6o7su">
                Yes! I want the pack
              </CtaButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}